<template>
  <div id="survey-question-page" v-if="survey">
    <b-row id="survey-header" no-gutters>
      <b-col>
        <div class="content-heading">
          <i class="ic-head-icon">
            <img src="@/assets/images/sidebar/survey.svg" alt="Survey Icon" />
          </i>
          <router-link :to="{name: 'survey'}" class="head-title">Survey</router-link>
          <i class="ic-tooltip" id="help"></i>
          <b-popover
            target="help"
            triggers="hover"
            content="Customize and publish your survey"
          >
          </b-popover>
          <div class="head-tabs">
            <b-nav tabs>
              <b-nav-item :to="{ name: 'surveyQuestion', params: { uuid } }">
                Survey Question
              </b-nav-item>
              <b-nav-item :to="{ name: 'surveyDesign', params: { uuid } }">
                Design
              </b-nav-item>
            </b-nav>
          </div>
        </div>
      </b-col>
    </b-row>
    <div class="content-body survey-body" v-if="survey">
      <b-container fluid>
        <b-row>
          <b-col cols="1.5">
            <b-container>  

              <b-btn
                variant="ghost"
                class="btn-cancel"
                style="border-radius:10px"
                @click='()=>{
                      this.$router.push({ name: "survey" });}'
              >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor" 
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="icon"
              >
                <path d="M19 12H5"></path>
                <path d="M12 19l-7-7 7-7"></path>
              </svg>

                Back
              </b-btn>
            </b-container>
          </b-col>
          <b-col cols="10">
            <b-container>
              <b-row class="mb-3">
                <b-col md="8">
                  <span id="heading">
                    {{ survey.title | truncate }}
                  </span>
                  <i class="action-button">
                    <img
                      src="@/assets/images/actions/edit.svg"
                      alt="Edit Button"
                      @click="$root.$emit('bv::show::modal', 'edit-survey-modal')"
                    />
                  </i>
                </b-col>
                <b-col class="ml-auto mt-2 mt-md-0 text-md-right">
                  <span id="total-questions"
                    >Total Questions: {{ totalQuestions }}</span
                  >
                </b-col>
              </b-row>
              <!-- SURVEY DRAGGABLE LIST START -->
              <SurveyDraggableList
                v-if="transformedSurvey"
                :survey="transformedSurvey"
                @add-question="addQuestion"
                :isUcoin="isMerchantUcoin"
              />
              <!-- SURVEY DRAGGABLE LIST END -->
              <b-row class="mt-3 mt-md-5">
                <b-col md="3" class="text-center">
                  <b-button
                    variant="primary btn-add"
                    @click="$root.$emit('bv::show::modal', 'create-page-modal')"
                    :disabled="isReadOnly"
                  >
                    Create New Page
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <!-- MODALS START -->
    <EditSurveyModal />
    <CreatePageModal :surveyId="survey.id" />
    <AnalyticsCodeModal />
    <DeleteQuestionElementModal />
    <ConfirmSaveCancelQuestionModal @question-saved="getSurvey(survey.uuid)" />
    <BirthdayPreviewModal />
    <GenderPreviewModal />
    <CivilStatusPreviewModal />
    <ParenthoodPreviewModal />
    <CityInputTypeModal />
    <ProvinceInputTypeModal />
    <!-- MODALS END-->
  </div>
</template>

<script>
import { truncate } from "lodash";
import draggable from "vuedraggable";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import SurveyDraggableList from "../lists/SurveyDraggableList";
import EditSurveyModal from "../modals/EditSurveyModal";
import CreatePageModal from "../modals/CreatePageModal";
import AnalyticsCodeModal from "../modals/AnalyticsCodeModal";
import DeleteQuestionElementModal from "../modals/DeleteQuestionElementModal";
import ConfirmSaveCancelQuestionModal from "../modals/ConfirmSaveCancelQuestionModal";
import BirthdayPreviewModal from "../modals/BirthdayPreviewModal";
import CivilStatusPreviewModal from "../modals/CivilStatusPreviewModal";
import GenderPreviewModal from "../modals/GenderPreviewModal";
import ParenthoodPreviewModal from "../modals/ParenthoodPreviewModal";
import CityInputTypeModal from "../modals/CityInputTypeModal";
import ProvinceInputTypeModal from "../modals/ProvinceInputTypeModal";

export default {
    name: "SurveyQuestionPage",
    props: ["uuid"],
    data() {
        return {
            pageId: null,
            surveyId: null,
            questionId: null,
            survey_content: null,
            isMerchantUcoin: null
        };
    },
    mounted() {
        this.$root.$on("contact-add-field", req => {
            const field = {
                type: req.type,
                placeholder: null,
                visible: true,
                required: true,
                isDisabled: false,
                label: req.type,
                gigya_answer_id: null
            };

            if (req.type === "Birthday") {
                field.placeholder = null;
                field.isDisabled = true;
            } else if (req.type === "Address") {
                field["options"] = [
                    {
                        type: "Address 1",
                        label: "Address 1",
                        placeholder: null,
                        visible: true,
                        required: true,
                        gigya_answer_id: null
                    },
                    {
                        type: "Address 2",
                        label: "Address 2",
                        placeholder: null,
                        visible: true,
                        required: true,
                        gigya_answer_id: null
                    },
                    {
                        type: "City",
                        label: "City",
                        placeholder: null,
                        visible: true,
                        required: true,
                        input_type: "textbox",
                        gigya_answer_id: null
                    },
                    {
                        type: "Province",
                        label: "Province",
                        placeholder: null,
                        visible: true,
                        required: true,
                        input_type: "textbox",
                        gigya_answer_id: null
                    },
                    {
                        type: "Zip Code",
                        label: "Zip Code",
                        placeholder: null,
                        visible: true,
                        required: true,
                        gigya_answer_id: null
                    }
                ];
            }

            let addedFields = null;

            if (req.question_uuid) {
                addedFields = this.survey.pages[req.pageIndex].questions
                    .find(question => question.uuid === req.question_uuid)
                    .contents.elements.map(field => field.type);

                if (
                    !addedFields.includes(field.type) ||
                    field.type === "Custom Fields"
                ) {
                    this.survey.pages[req.pageIndex].questions
                        .find(question => question.uuid === req.question_uuid)
                        .contents.elements.push(field);
                }
                this.setStringifyContent({
                    page_index: req.pageIndex,
                    question_type: req.question_type,
                    question_uuid: req.question_uuid
                });
            } else {
                addedFields = this.survey.pages[req.pageIndex].questions[
                    req.questionIndex
                ].contents.elements.map(field => field.type);

                if (
                    !addedFields.includes(field.type) ||
                    field.type === "Custom Fields"
                ) {
                    this.survey.pages[req.pageIndex].questions[
                        req.questionIndex
                    ].contents.elements.push(field);
                }
            }
        });
        this.$root.$on("multiple-choice-add-field", req => {
             this.survey.pages[req.pageIndex].questions
                    .find(question => question.uuid === req.question_uuid)
                    .contents.images.push({ "key": this.survey.pages[req.pageIndex].questions
                    .find(question => question.uuid === req.question_uuid)
                    .contents.images.length, "image": "", "aspectRatio": "", "prefix": "", "width": "", "height": "", "base64": "", "fileName": "", "fileType": "", "showImage": false });
            if (req.question_uuid) {
                this.survey.pages[req.pageIndex].questions
                    .find(question => question.uuid === req.question_uuid)
                    .contents.elements.push("");
                // this.$nextTick(() => {
                //     this.setStringifyContent({
                //         page_index: req.pageIndex,
                //         question_uuid: req.question_uuid,
                //         question_type: req.question_type
                //     });
                // });
            } else {
                this.survey.pages[req.pageIndex].questions[
                    req.questionIndex
                ].contents.elements.push("");
                this.survey.pages[req.pageIndex].questions[
                    req.questionIndex
                ].contents.gigya_answer_ids.push("");
            }
        });
        this.$root.$on("question-deleted", () => {
            this.getSurvey(this.survey.uuid);
        });
        this.$root.$on("rating-add-label", req => {
            if (req.question_uuid) {
                const question = this.survey.pages[
                    req.pageIndex
                ].questions.find(
                    question => question.uuid === req.question_uuid
                );
                question.contents.elements.push({ label: null });
                question.contents.gigya_answer_ids.push({ label: null });
                this.$nextTick(() => {
                    this.setStringifyContent({
                        page_index: req.pageIndex,
                        question_uuid: req.question_uuid,
                        question_type: req.question_type
                    });
                });
            } else {
                const question = this.survey.pages[req.pageIndex].questions[
                    req.questionIndex
                ];
                question.contents.elements.push({ label: null });
                question.contents.gigya_answer_ids.push({ label: null });
            }
        });
    },
    beforeDestroy() {
        this.$root.$off("contact-add-field");
        this.$root.$off("multiple-choice-add-field");
        this.$root.$off("question-deleted");
        this.$root.$off("rating-add-label");
    },
    methods: {
        ...mapActions("surveys", ["getSurvey", "isUcoin"]),
        ...mapMutations("surveys", [
            "setSurvey",
            "setStringifyContent",
            "setErrors",
        ]),
        async onGetSurvey() {
            await this.getSurvey(this.survey.uuid).then(() => {
                if (
                    this.errors === null ||
                    Object.keys(this.errors).length === 0
                ) {
                    this.$root.$emit("bv::show::modal", "edit-survey-modal");
                }
            });
        },
        async checkUcoin() {
            this.isMerchantUcoin = await this.isUcoin();
        },
        addQuestion(req) {
            this.setErrors(null);
            const page = this.survey.pages.find(page => page.id === req.pageId);

            let question = {
                page_uuid: page.uuid,
                question: null,
                sort: page.questions.length,
                is_enabled: true,
                title: "Your Question",
                gigya_question_id: null,
                image: { "id": 0, "key": 0, "image": "", "aspectRatio": "", "prefix": "", "width": "", "height": "", "base64": "", "fileName": "", "fileType": "","showImage": false },
            };
            
            const defaultMultipleChoice = {
                page_uuid: page.uuid,
                question: null,
                sort: page.questions.length,
                is_enabled: true,
                title: "Your Question",
                gigya_question_id: null,
                contents: {
                    images: [{ "key": 0, "image": "", "aspectRatio": "", "prefix": "", "width": "", "height": "", "base64": "", "fileName": "", "fileType": "", "showImage": false }, { "key": 1, "image": "", "aspectRatio": "", "prefix": "", "width": "", "height": "", "base64": "", "fileName": "", "fileType": "", "showImage": false }],
                    elements: ["", ""],
                    gigya_answer_ids: ["", ""],
                    width: "full",
                    visible: true,
                    required: true
                },
                image: { "id": 0, "key": 0, "image": "", "aspectRatio": "", "prefix": "", "width": "", "height": "", "base64": "", "fileName": "", "fileType": "","showImage": false }
            };

            switch (req.type) {
                case "Contact Details":
                    question["question_type"] = "contact_details";
                    question["contents"] = {
                        elements: [
                            {
                                type: "First Name",
                                label: "First Name",
                                placeholder: null,
                                visible: true,
                                required: true,
                                gigya_answer_id: null
                            },
                            {
                                type: "Last Name",
                                label: "Last Name",
                                placeholder: null,
                                visible: true,
                                required: true,
                                gigya_answer_id: null
                            }
                        ]
                    };
                    break;
                case "Multiple Choice":
                    defaultMultipleChoice["question_type"] = "multiple_choice";
                    question = defaultMultipleChoice;
                    break;
                case "Checkbox":
                    defaultMultipleChoice["question_type"] = "checkbox";
                    // defaultMultipleChoice.contents["limit"] = null;
                    defaultMultipleChoice.contents.width = "half";
                    question = defaultMultipleChoice;
                    break;
                case "Dropdown":
                    defaultMultipleChoice["question_type"] = "dropdown";
                    defaultMultipleChoice.contents.width = "half";
                    question = defaultMultipleChoice;
                    break;
                case "Open-Ended":
                    question["question_type"] = "open_ended";
                    question["contents"] = {
                        gigya_answer_id: null,
                        visible: true,
                        required: true,
                        char_length: null,
                        placeholder: null
                    };
                    break;
                case "File Upload":
                    question["question_type"] = "file_upload";
                    question["contents"] = {
                        gigya_answer_id: null,
                        visible: true,
                        required: true,
                        size_limit: null,
                        allowed_file_types: []
                    };
                    break;
                case "Rating":
                    question["question_type"] = "rating";
                    question["contents"] = {
                        visible: true,
                        required: true,
                        icon: null,
                        elements: [
                            { label: "Poor" },
                            { label: "Bad" },
                            { label: "Good" },
                            { label: "Better" },
                            { label: "Best" }
                        ],
                        gigya_answer_ids: [
                            { gigya_answer_id: "" },
                            { gigya_answer_id: "" },
                            { gigya_answer_id: "" },
                            { gigya_answer_id: "" },
                            { gigya_answer_id: "" }
                        ]
                    };
                    break;
            }

            page.questions.push(question);

            this.$nextTick(() => {
                const page = this.transformedSurvey.pages.find(
                    page => page.id === req.pageId
                );
                const pageIndex = this.transformedSurvey.pages.indexOf(page);
                const questionIndex = page.questions.length - 1;

                const isPageOpen = document
                    .getElementById(`page-accordion-${pageIndex}`)
                    .classList.value.includes("show");
                if (!isPageOpen)
                    this.$root.$emit(
                        "bv::toggle::collapse",
                        `page-accordion-${pageIndex}`
                    );
                this.$root.$emit(
                    "bv::toggle::collapse",
                    `question-accordion-${pageIndex}-${questionIndex}`
                );

                const questionAccordion = document.getElementById(
                    `question-accordion-${pageIndex}-${questionIndex}`
                );

                setTimeout(() => {
                    questionAccordion.scrollIntoView({ behavior: "smooth" });
                }, 500);
            });
        }
    },
    filters: {
        truncate(value) {
            return truncate(value, { length: 80 });
        }
    },
    computed: {
        ...mapGetters("surveys", [
            "totalQuestions",
            "errors",
            "survey",
            "isReadOnly"
        ]),
        activeSurvey: {
            get() {
                return JSON.parse(localStorage.getItem("activeSurvey"));
            }
        },
        transformedSurvey() {
            const survey = this.survey;
            if(survey.pages){
                survey.pages.map(page => {
                    page["questions"] = page.questions
                        .sort((a, b) => {
                            return a.sort - b.sort;
                        })
                        .map(question => {
                            const parsedQuestionContent = question.content
                                ? JSON.parse(question.content)
                                : null;
                            let transformedContents = {};

                            if (
                                question.question_type === "multiple_choice" ||
                                question.question_type === "checkbox" ||
                                question.question_type === "dropdown"
                            ) {
                                transformedContents = {
                                    width: parsedQuestionContent
                                        ? parsedQuestionContent[0].attributes.width
                                        : "full",
                                    visible: parsedQuestionContent
                                        ? parsedQuestionContent[0].visible
                                        : true,
                                    required: parsedQuestionContent
                                        ? parsedQuestionContent[0].required
                                        : true,
                                    elements: parsedQuestionContent
                                        ? parsedQuestionContent[0].attributes.options.map(
                                            ({ answer }) => answer
                                        )
                                        : ["", ""],
                                    images: parsedQuestionContent &&
                                            parsedQuestionContent[0].attributes &&
                                            parsedQuestionContent[0].attributes.images
                                        ? parsedQuestionContent[0].attributes.images = parsedQuestionContent[0].attributes.images.map(image => ({
                                        ...image, image: image.image? image.image:"", aspectRatio: "", prefix: "", width: "", height: "", base64: "",fileName: "", fileType: "","showImage": image.image? true: false
                                        }))
                                        : [{ "key": "", "image": "", "aspectRatio": "", "prefix": "", "width": "", "height": "", "base64": "", "fileName": "", "fileType": "","showImage": false },
                                            { "key": "", "image": "", "aspectRatio": "", "prefix": "", "width": "", "height": "", "base64": "", "fileName": "", "fileType": "","showImage": false }],
                                    gigya_answer_ids:
                                        parsedQuestionContent &&
                                        parsedQuestionContent[0].attributes
                                            .gigya_answer_ids != undefined
                                            ? parsedQuestionContent[0].attributes.gigya_answer_ids.map(
                                                ({ gigya_answer_id }) =>
                                                    gigya_answer_id
                                            )
                                            : ["", ""]
                                };
                            } else if (
                                question.question_type === "contact_details"
                            ) {
                                transformedContents = {
                                    elements: parsedQuestionContent
                                        ? parsedQuestionContent.map(element => {
                                            const field = {
                                                label: element.attributes.label,
                                                placeholder:
                                                    element.attributes.type ===
                                                        "Birthday" ||
                                                    element.attributes.type ===
                                                        "Gender" ||
                                                    element.attributes.type ===
                                                        "Civil Status" ||
                                                    element.attributes.type ===
                                                        "Parenthood"
                                                        ? null
                                                        : element.attributes
                                                                .placeholder,
                                                type: element.attributes.type,
                                                visible: element.visible,
                                                required: element.required,
                                                gigya_answer_id:
                                                    element.gigya_answer_id,
                                                isDisabled:
                                                    element.attributes.type ===
                                                        "Birthday" ||
                                                    element.attributes.type ===
                                                        "Parenthood" ||
                                                    element.attributes.type ===
                                                        "Gender" ||
                                                    element.attributes.type ===
                                                        "Civil Status"
                                            };
                                            if (
                                                Object.keys(element).includes(
                                                    "options"
                                                ) ||
                                                Object.keys(
                                                    element.attributes
                                                ).includes("options")
                                            )
                                                field["options"] = Object.keys(
                                                    element.attributes
                                                ).includes("options")
                                                    ? element.attributes.options
                                                    : element.options;
                                            return field;
                                        })
                                        : [
                                            {
                                                label: null,
                                                placeholder: null,
                                                type: "First Name",
                                                visible: true,
                                                required: true,
                                                isDisabled: false,
                                                gigya_answer_id: null
                                            }
                                        ]
                                };
                            } else if (question.question_type === "open_ended") {
                                transformedContents = {
                                    visible: parsedQuestionContent
                                        ? parsedQuestionContent[0].visible
                                        : true,
                                    required: parsedQuestionContent
                                        ? parsedQuestionContent[0].required
                                        : true,
                                    char_length: parsedQuestionContent
                                        ? parsedQuestionContent[0].attributes
                                            .char_length
                                        : null,
                                    placeholder: parsedQuestionContent
                                        ? parsedQuestionContent[0].attributes
                                            .placeholder
                                        : null,
                                    gigya_answer_id: parsedQuestionContent
                                        ? parsedQuestionContent[0].gigya_answer_id
                                        : null
                                };
                            } else if (question.question_type === "file_upload") {
                                transformedContents = {
                                    visible: parsedQuestionContent
                                        ? parsedQuestionContent[0].visible
                                        : true,
                                    required: parsedQuestionContent
                                        ? parsedQuestionContent[0].required
                                        : true,
                                    size_limit: parsedQuestionContent
                                        ? parsedQuestionContent[0].attributes
                                            .size_limit
                                        : null,
                                    allowed_file_types: parsedQuestionContent
                                        ? parsedQuestionContent[0].attributes
                                            .allowed_file_types
                                        : null,
                                    gigya_answer_id: parsedQuestionContent
                                        ? parsedQuestionContent[0].gigya_answer_id
                                        : null
                                };
                            } else if (question.question_type === "rating") {
                                transformedContents = {
                                    visible: parsedQuestionContent
                                        ? parsedQuestionContent[0].visible
                                        : true,
                                    required: parsedQuestionContent
                                        ? parsedQuestionContent[0].required
                                        : true,
                                    icon: parsedQuestionContent
                                        ? parsedQuestionContent[0].attributes.icon
                                        : null,
                                    elements: parsedQuestionContent
                                        ? parsedQuestionContent[0].attributes.options.map(
                                            rating => {
                                                return {
                                                    label: rating.label
                                                };
                                            }
                                        )
                                        : [
                                            { label: "Poor" },
                                            { label: "Bad" },
                                            { label: "Good" },
                                            { label: "Better" },
                                            { label: "Best" }
                                        ],
                                    gigya_answer_ids: parsedQuestionContent
                                        ? parsedQuestionContent[0].attributes.gigya_answer_ids.map(
                                            gigya_answer_id => {
                                                return {
                                                    gigya_answer_id:
                                                        gigya_answer_id.gigya_answer_id
                                                };
                                            }
                                        )
                                        : [
                                            { gigya_answer_id: "" },
                                            { gigya_answer_id: "" },
                                            { gigya_answer_id: "" },
                                            { gigya_answer_id: "" },
                                            { gigya_answer_id: "" }
                                        ]
                                };
                            }
                            question["title"] = "Your Question";
                            question["contents"] = transformedContents;
                            
                            let questionImage = "";
                            
                            if(question["image"] && typeof question["image"] == "string") {

                                questionImage = question['image']? question['image']:''
                            }
                            else if (question["image"] && typeof question["image"] == "object") {
                                questionImage = question['image']['image']
                            }
                            else{
                                questionImage = ""
                            }

                            question['image']= {"id": question.length,"key":0, "image":  questionImage, "aspectRatio": "", "prefix": "", "width": "", "height": "", "base64": "", "fileName": "", "fileType": "", "showImage": question['image']? true: false}

                            return question;
                        });
                });
            }
            return survey;
        }
    },
    created() {
        if (this.uuid === undefined) {
            this.$router.push({ name: "survey" });

            return;
        }
        this.checkUcoin();
        this.getSurvey(this.uuid);
    },
    components: {
        SurveyDraggableList,
        draggable,
        EditSurveyModal,
        CreatePageModal,
        AnalyticsCodeModal,
        DeleteQuestionElementModal,
        ConfirmSaveCancelQuestionModal,
        BirthdayPreviewModal,
        GenderPreviewModal,
        CivilStatusPreviewModal,
        ParenthoodPreviewModal,
        CityInputTypeModal,
        ProvinceInputTypeModal
    }
};
</script>
<style lang="scss">
</style>
